import { useEffect, useRef, useState } from 'react';
// import axios from '@/services/axiosInstance';
import axiosInstance from "../helpers/Axios";
import { Box, Typography } from '@mui/material';

type Props = {
  value: string | null;
  onChange: (value: string | null) => void;
  folder: string; // ✅ NOUVEAU
  label?: string; // optionnel (UI)
};

// type Props = {
//   value: string | null;
//   onChange: (value: string | null) => void;
// };

const StageImagePicker = ({ value, onChange, folder, label }: Props) => {
  const [images, setImages] = useState<string[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);


    const loadImages = async () => {
      const res = await axiosInstance   .get('/image');

      const folderData = res.data.find(
        (f: any) => f.name === folder
      );

      if (folderData?.files) {
        setImages(folderData.files.sort());
      }
    };

  useEffect(() => {
    loadImages();
  }, [folder]);


  const handleUpload = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    await axiosInstance.post(`/image/${folder}`, formData);

    await loadImages();

    // ✅ sélectionner automatiquement l’image uploadée
    onChange(`/images/${folder}/${file.name}`);
  };


  const isSelected = (file: string) =>
    value === `/images/${folder}/${file}`;

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        {label ?? 'Image'}
      </Typography>

      {/* Bouton "aucune image" */}
      <Box
        onClick={() => onChange(null)}
        sx={{
          mb: 2,
          cursor: 'pointer',
          color: !value ? 'primary.main' : 'text.secondary',
          fontWeight: !value ? 'bold' : 'normal',
        }}
      >
        ❌ Aucune image
      </Box>

      {/* Grille de vignettes */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, 120px)',
          gap: 2,
        }}
      >
        {/* ➕ Tuile upload */}
        <Box
          onClick={() => inputRef.current?.click()}
          sx={{
            height: 120,
            borderRadius: 2,
            border: '2px dashed #999',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            color: '#666',
            '&:hover': {
              borderColor: 'primary.main',
              color: 'primary.main',
            },
          }}
        >
          <div style={{ fontSize: 32 }}>＋</div>
          <div style={{ fontSize: 12, textAlign: 'center' }}>
            Ajouter<br />une image
          </div>

          <input
            ref={inputRef}
            type="file"
            hidden
            accept="image/*"
            onChange={e =>
              e.target.files && handleUpload(e.target.files[0])
            }
          />
        </Box>

        {/* Images existantes */}
        {images.map(file => {
          const src = `${import.meta.env.VITE_BACKEND_URL}/images/${folder}/${file}`;
          const selected = isSelected(file);

          return (
            


            <Box
              key={file}
              onClick={() => onChange(`/images/${folder}/${file}`)}
              sx={{
                borderRadius: 2,
                overflow: 'hidden',
                cursor: 'pointer',
                border: selected
                  ? '3px solid #1976d2'
                  : '2px solid transparent',
                boxShadow: selected
                  ? '0 0 0 3px rgba(25,118,210,0.3)'
                  : '0 4px 10px rgba(0,0,0,0.2)',
                transition: 'all 0.2s',
                '&:hover': {
                  transform: 'scale(1.03)',
                },
              }}
            >
              <img
                src={src}
                alt={file}
                style={{
                  width: '100%',
                  height: 120,
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default StageImagePicker;